import { SaveButton } from '@/components/_common';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { useWindowSize } from '@/hooks';
import { Button } from 'antd';

interface Props {
  saveLoading?: boolean;
  handleSubmit: VoidFunction;
  handleVerifyEmail: VoidFunction;
  verifyEmailLoading?: boolean;
}
export default function EmailSettingsFooterActions(props: Props) {
  const { width } = useWindowSize();

  return (
    <SpaceForButton style={{ marginTop: '16px' }}>
      {width < 992 && (
        <SaveButton
          block
          onClick={props.handleSubmit}
          loading={props.saveLoading}
        >
          Salvar
        </SaveButton>
      )}

      <Button
        type="primary"
        block
        onClick={props.handleVerifyEmail}
        loading={props.verifyEmailLoading}
      >
        Verificar e-mail
      </Button>
    </SpaceForButton>
  );
}
